module.exports = __webpack_public_path__ + "img/publons.d951c525.png";